export var DefaultTransformKey;
(function (DefaultTransformKey) {
    DefaultTransformKey["color"] = "key";
    DefaultTransformKey["d"] = "path";
})(DefaultTransformKey || (DefaultTransformKey = {}));
